import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/return-policy-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark’s Easy-to-Use Return Policy</title>
        <meta
          name='description'
          content="When you receive an item you don't want, you can return it for an exchange, refund, or store credit with Poshmark’s easy-to-use return policy."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/return-policy-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/return-policy-poshmark' />
        <meta property='og:title' content='Poshmark’s Easy-to-Use Return Policy' />
        <meta
          property='og:description'
          content="When you receive an item you don't want, you can return it for an exchange, refund, or store credit with Poshmark’s easy-to-use return policy."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
